module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-box"
  }, [_c('h4', {
    staticClass: "header-title m-t-0 m-b-20"
  }, [_vm._v("\n    Documents\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "file-list"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "content": "Envoyer un document"
    }
  }, [_c('el-upload', {
    staticClass: "file-list-item",
    staticStyle: {
      "padding": "0",
      "border": "0"
    },
    attrs: {
      "drag": "",
      "action": _vm.uploadEndpointUrl,
      "show-file-list": false,
      "on-success": _vm.handleUploadSuccess,
      "on-progress": _vm.handleUploadProgress,
      "before-upload": _vm.beforeUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-plus",
    staticStyle: {
      "margin-top": "25%"
    }
  })])], 1), _vm._v(" "), _vm._l((_vm.orderedDocuments), function(document) {
    return _c('el-tooltip', {
      key: document.id,
      staticClass: "item",
      attrs: {
        "content": _vm.getStatus(document).text
      }
    }, [_c('div', {
      class: ['file-list-item', (_vm.isLinkedDocumentHovered(document) ? 'file-list-item-hovered' : '')],
      staticStyle: {
        "position": "relative"
      },
      on: {
        "mouseover": function($event) {
          return _vm.handleDocumentHover(document)
        },
        "mouseout": _vm.clearDocumentHover
      }
    }, [(document.type === 'uploads') ? _c('span', {
      staticStyle: {
        "position": "absolute",
        "right": "2px",
        "top": "0"
      },
      on: {
        "click": function($event) {
          return _vm.deleteDocument(document)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times text-danger",
      staticStyle: {
        "font-size": "22px"
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      on: {
        "click": function($event) {
          return _vm.downloadDocument(document)
        }
      }
    }, [(document.source_name) ? _c('source-app', {
      staticStyle: {
        "position": "absolute",
        "left": "2px",
        "top": "0"
      },
      attrs: {
        "name": document.source_name,
        "size": "tiny"
      }
    }) : _c('div', {
      staticStyle: {
        "position": "absolute",
        "left": "2px",
        "top": "0"
      }
    }, [_c('span', {
      staticClass: "label label-dark"
    }, [_vm._v("Envoyé")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "position": "absolute",
        "left": "55%",
        "top": "48px",
        "margin": "2px"
      }
    }, [_c('i', {
      class: ['fa', _vm.getStatus(document).icon, 'text-' + _vm.getStatus(document).color],
      staticStyle: {
        "font-size": "18px"
      }
    })]), _vm._v(" "), (document.type === 'invoices') ? _c('i', {
      staticClass: "fas fa-file-invoice-dollar"
    }) : _vm._e(), _vm._v(" "), (document.type === 'contracts') ? _c('i', {
      staticClass: "fas fa-file-signature"
    }) : _vm._e(), _vm._v(" "), (document.type === 'estimates') ? _c('i', {
      staticClass: "fas fa-file-invoice"
    }) : _vm._e(), _vm._v(" "), (document.type === 'uploads') ? _c('i', {
      staticClass: "fas fa-file-upload"
    }) : _vm._e(), _vm._v(" "), (document.type === 'invoices') ? _c('div', {
      staticClass: "name"
    }, [_c('strong', [_vm._v("Facture")]), _vm._v("\n            (" + _vm._s(new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR'
    }).format(document.amount_total)) + ")\n          ")]) : (document.type === 'contracts') ? _c('div', {
      staticClass: "name"
    }, [_c('strong', [_vm._v("Contrat")])]) : (document.type === 'estimates') ? _c('div', {
      staticClass: "name"
    }, [_c('strong', [_vm._v("BDC")]), _vm._v("\n            (" + _vm._s(new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR'
    }).format(document.amount_total)) + ")\n          ")]) : (document.type === 'uploads') ? _c('div', {
      staticClass: "name"
    }, [_c('strong', [_vm._v(_vm._s(document.file_name))])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "date"
    }, [_vm._v(_vm._s(_vm._f("moment")(document.created_at, 'DD/MM/YYYY')))])], 1)])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "m-t-20 row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('el-tooltip', {
    attrs: {
      "content": "Filtrer les sociétés"
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "Société :"
    },
    model: {
      value: (_vm.displayType.selected),
      callback: function($$v) {
        _vm.$set(_vm.displayType, "selected", $$v)
      },
      expression: "displayType.selected"
    }
  }, _vm._l((_vm.displayType.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.hideInvoices),
      callback: function($$v) {
        _vm.hideInvoices = $$v
      },
      expression: "hideInvoices"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("Cacher les factures")])])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Envoi d'un document",
      "close-on-click-modal": false,
      "visible": _vm.dialog.visible,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialog, "visible", $event)
      }
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "label-position": "top",
      "label-width": "150px",
      "model": _vm.form,
      "rules": _vm.fields.validation
    }
  }, [_c('el-row', {
    staticClass: "m-b-20",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-progress', {
    attrs: {
      "text-inside": true,
      "stroke-width": 18,
      "status": _vm.upload.progression === 100 ? 'success' : '',
      "percentage": _vm.upload.progression
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "uploadable_type",
      "label": "Type du document"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.form.uploadable_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "uploadable_type", $$v)
      },
      expression: "form.uploadable_type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Autre",
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Bon de commande",
      "value": "App\\Estimate"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Contrat",
      "value": "App\\Contract"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Facture",
      "value": "App\\Invoice"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [(_vm.form.uploadable_type !== '') ? _c('el-form-item', {
    attrs: {
      "prop": "uploadable_id",
      "label": "Document original lié"
    }
  }, [_c('el-select', {
    staticClass: "form-control",
    attrs: {
      "placeholder": "Selectionnez un document original"
    },
    model: {
      value: (_vm.form.uploadable_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "uploadable_id", $$v)
      },
      expression: "form.uploadable_id"
    }
  }, [_vm._l(([].concat( _vm.relations.invoices ).sort(function (a, b) { return _vm.moment(a.created_at).isBefore(b.created_at); })), function(invoice) {
    return (_vm.form.uploadable_type === 'App\\Invoice') ? _c('el-option', {
      key: 'invoice_' + invoice.id,
      attrs: {
        "value": invoice.id,
        "label": 'Facture (' + new Intl.NumberFormat('fr-FR', {
          style: 'currency',
          currency: 'EUR'
        }).format(invoice.amount_total) + ') du ' + _vm.moment(invoice.created_at).format('DD/MM/YYYY')
      }
    }) : _vm._e()
  }), _vm._v(" "), _vm._l(([].concat( _vm.relations.contracts ).sort(function (a, b) { return _vm.moment(a.created_at).isBefore(b.created_at); })), function(contract) {
    return (_vm.form.uploadable_type === 'App\\Contract') ? _c('el-option', {
      key: 'contract_' + contract.id,
      attrs: {
        "value": contract.id,
        "label": 'Contrat du ' + _vm.moment(contract.created_at).format('DD/MM/YYYY')
      }
    }) : _vm._e()
  }), _vm._v(" "), _vm._l(([].concat( _vm.relations.estimates ).sort(function (a, b) { return _vm.moment(a.created_at).isBefore(b.created_at); })), function(estimate) {
    return (_vm.form.uploadable_type === 'App\\Estimate') ? _c('el-option', {
      key: 'estimate_' + estimate.id,
      attrs: {
        "value": estimate.id,
        "label": 'BDC (' + new Intl.NumberFormat('fr-FR', {
          style: 'currency',
          currency: 'EUR'
        }).format(estimate.amount_total) + ') du ' + _vm.moment(estimate.created_at).format('DD/MM/YYYY')
      }
    }) : _vm._e()
  })], 2)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "file_name",
      "label": "Nom du fichier"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Saisissez le nom du fichier"
    },
    model: {
      value: (_vm.form.file_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "file_name", $$v)
      },
      expression: "form.file_name"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialog.visible = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.form.file_url === null) ? _c('span', [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": true
    }
  }, [_vm._v("Envoi en cours ...")])], 1) : _c('span', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v("Créer le document")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7598bc58"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents/Main/Customers/ServiceAndDocuments/CustomerDocuments.vue
// module id = 711
// module chunks = 1